/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { AdDesignIndexPathParams, AdDesignIndexResponse } from '../types/AdDesignIndex'

/**
 * GET /organisations/:organisation/ad-designs
 * @see backend/nexus/modules/Organisation/Http/Controllers/AdDesignController.php AdDesignController::index
 */
export async function adDesignIndex(
	organisation: AdDesignIndexPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AdDesignIndexResponse>> {
	return axiosInstance.get(`/organisations/${organisation}/ad-designs`, config)
}
